import React from 'react';
import _ from 'lodash';

import Warning from 'components/Warning';
import StepSection from 'components/StepSection';
import BookingStatus from 'components/BookingStatus';
import {default as Modal, withModal} from 'components/Modal';

import {fetchMemberCheckOutInfo, fetchPaymentSummary} from 'ducks/frontDesk';

import {
  BookingType,
  Buttons,
  InfoSection,
  PaymentSummary,
  TenantCard,
  CheckList
} from 'containers/FrontDesk/components/shared';

import {MODALS as BASE_MODALS, openModal, closeModal} from 'ducks/modals';

import {formatDate} from 'utils/datetime';

import './styles.css';

class MemberCheckOutModal extends React.Component<any> {
  componentDidMount() {
    const {locationRef, bookingId} = this.props.data;

    const extraActions = this.props.storeDataExtraActions(data => ({
      memberCheckOutInfo: data
    }));

    this.props.fetchMemberCheckOutInfo({locationRef, bookingId}, extraActions);

    this.props.fetchPaymentSummary({locationRef, bookingId}, [
      ...this.props.storeDataExtraActions(data => ({
        paymentSummary: data
      }))
    ]);
  }

  checkOutTenants = () => {
    const extraActions = [
      ...this.props.closeModalExtraActions,
      ...this.props.getExtraActions(),
      () => closeModal(BASE_MODALS.CONFIRM)
    ];

    this.props.openModal(BASE_MODALS.CONFIRM, {
      heading: 'Check out member',
      question: 'Are you sure you want to check out this member?',
      confirmAction: () => this.props.data.confirmAction(extraActions)
    });
  };

  render() {
    const {
      closeModal,
      data: {memberCheckOutInfo, paymentSummary, warning}
    } = this.props;

    const primaryTenant = _.get(memberCheckOutInfo, 'primaryTenant');
    const secondaryTenant = _.get(memberCheckOutInfo, 'secondaryTenant');

    let info: Array<any> = [];
    if (!_.isNil(memberCheckOutInfo)) {
      const {
        roomNumber,
        moveIn,
        moveOut,
        duration,
        bookingType,
        bookingOrganisation
      } = memberCheckOutInfo;
      info = [
        {header: 'Room', text: roomNumber},
        {header: 'Move-In', text: formatDate(moveIn)},
        {header: 'Move-Out', text: formatDate(moveOut)},
        {header: 'Duration', text: duration},
        {header: 'Booking Type', text: bookingType},
        {header: 'Booking Organisation', text: bookingOrganisation || 'N/A'}
      ];
    }

    const checkListItems = [
      {
        name: 'roomCleanedAndRubbishRemoved',
        label: 'Room clean and rubbish removed?',
        defaultChecked: false
      },
      {
        name: 'postBoxCheckedAndKeyReturned',
        label: 'Post box checked and key returned?',
        defaultChecked: false
      },
      {
        name: 'keyCardCleared',
        label: 'Key card cleared?',
        defaultChecked: false
      },
      {
        name: 'inventorySigned',
        label: 'Inventory signed?',
        defaultChecked: false
      },
      {
        name: 'residentSignedOut',
        label: 'Resident signed out?',
        defaultChecked: false
      }
    ];

    const modalType = secondaryTenant ? Modal.MEDIUM : Modal.SUB_MEDIUM;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={modalType}
        className="MemberCheckOutModal">
        <Modal.Header>
          <BookingType bookingType={_.get(memberCheckOutInfo, 'bookingType')} />
          <div className="headingAndStatus">
            <h3 className="heading">
              {_.get(memberCheckOutInfo, 'bookingType')} Checkout
            </h3>
            {memberCheckOutInfo && (
              <BookingStatus status={memberCheckOutInfo.bookingStatus} />
            )}
          </div>
        </Modal.Header>
        {memberCheckOutInfo && (
          <Modal.Body>
            {warning && <Warning>{warning}</Warning>}

            <InfoSection info={info} />

            <StepSection
              step="1"
              header="Check that the member's personal details are up to date">
              <TenantCard tenant={primaryTenant} />
              {secondaryTenant && <TenantCard tenant={secondaryTenant} />}
            </StepSection>

            <StepSection step="2" header="Payment summary">
              <div className="paymentSummary">
                <PaymentSummary paymentSummary={paymentSummary} />
              </div>
            </StepSection>

            <StepSection step="3" header="Check List">
              <CheckList items={checkListItems} />
            </StepSection>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Buttons
            closeModal={closeModal}
            onSubmit={this.checkOutTenants}
            active={true}
            submitting={false}
            label="Check out"
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => {
  return {};
};

const mapDispatchToProps = {
  fetchMemberCheckOutInfo,
  openModal,
  fetchPaymentSummary
};

export default withModal(
  BASE_MODALS.MEMBER_CHECK_OUT,
  mapStateToModalData,
  mapDispatchToProps
)(MemberCheckOutModal);
